export const ETrfVehicleCategory = {
   0: "UNKNOWN",
   1: "CAR",
   2: "MINIVAN",
   3: "VAN",
   4: "MINIBUS",
   5: "MIDIBUS",
   6: "OTOBUS",
   7: "MINIVAN_VIP",
   "-1": "ALL",
};

export const ETrfSaleStatus = {
   0: "UNKNOWN",
   1: "OPEN",
   2: "CLOSE",
   "-1": "ALL",
};

export const ETrfAncillaryType = {
   0: "UNKNOWN",
   1: "BABYSEAT",
   2: "WHEELCHAIR",
   "-1": "ALL",
};

export const ETrfTnrStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "ISSUED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REISSUED",
   8: "ERROR",
   9: "OPEN",
   10: "PENDING",
   "-1": "ALL",
};

export const ETrfLegStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "ISSUED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REISSUED",
   8: "ERROR",
   9: "OPEN",
   10: "PENDING",
   "-1": "ALL",
};

export const ETrfAncillaryStatus = {
   0: "UNKNOWN",
   1: "ACTIVE",
   2: "PASSIVE",
   "-1": "ALL",
};

export const ETrfCommissionType = {
   0: "UNKNOWN",
   1: "GSA",
   2: "AGENCY",
   3: "PROVIDER",
   "-1": "ALL",
};

export const ETrfCommissionAmountType = {
   0: "UNKNOWN",
   1: "RATIO",
   2: "AMOUNT",
   "-1": "ALL",
};

export const ETrfOperationStatus = {
   0: "UNKNOWN",
   1: "OPEN",
   2: "LOCKED",
   3: "PLANNED",
   4: "COMPLETED",
   5: "NOSHOW",
   "-1": "ALL",
};

export const ETrfImportType = {
   0: "UNKNOWN",
   1: "AUTO",
   2: "MANUAL",
   "-1": "ALL",
};

export const ETrfTripType = {
   0: "UNKNOWN",
   1: "ONE_WAY",
   2: "ROUND_TRIP",
   "-1": "ALL",
};

export const ETrfRouteType = {
   0: "UNKNOWN",
   1: "AIRPORT_LOCATION",
   2: "LOCATION_AIRPORT",
   3: "LOCATION_LOCATION",
   4: "AIRPORT_AIRPORT",
   "-1": "ALL",
};

export const ETrfCommissionRatioType = {
   0: "UNKNOWN",
   1: "COMMISION",
   2: "MARKUP",
   "-1": "ALL",
};

export const ETrfCommisionType = {
   0: "UNKNOWN",
   1: "GTS",
   2: "GSA",
   3: "AGENCY",
   "-1": "ALL",
};

export const ETrfCommisionAmountType = {
   0: "UNKNOWN",
   1: "RATIO",
   2: "FIXED",
   "-1": "ALL",
};

export const ETrfTransferType = {
   0: "UNKNOWN",
   1: "INDIVIDUAL",
   2: "GROUP",
   "-1": "ALL",
};

export const ETrfProductType = {
   0: "UNKNOWN",
   1: "TRANSFER",
   2: "ANCILLARY",
   "-1": "ALL",
};

export const ETrfTravelerType = {
   0: "UNKNOWN",
   1: "ADULT",
   2: "CHILD",
   3: "INFANT",
   "-1": "ALL",
};

export const ETrfRouteOriginType = {
   0: "UNKNOWN",
   1: "FROM",
   2: "TO",
   3: "BOTH",
   "-1": "ALL",
};

export const ETrfMappingType = {
   0: "UNKNOWN",
   1: "LOCATION",
   "-1": "ALL",
};

export const ETrfMappingStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "MAPPED",
   3: "WONT_MAP",
   4: "NOT_PRESENT",
   5: "SUSPENDED",
   6: "UNMAPPED",
   "-1": "ALL",
};

export const ETrfFacilityType = {
   0: "UNKNOWN",
   1: "VOIDABLE_BEFORE_24H",
   2: "VOIDABLE_BEFORE_36H",
   3: "VOIDABLE_BEFORE_12H",
   "-1": "ALL",
};

export const ETrfTnrReverseEnabledType = {
   0: "UNKNOWN",
   1: "NON_REFUNDABLE",
   2: "REFUNDABLE_WO_PENALTY",
   3: "REFUNDABLE_WITH_PENALTY",
   4: "ALREADY_REVERSED",
   "-1": "ALL",
};
